import type { ActiveCallDetail } from '../../../../../utils/ringCentralDialer';

import './RingCentralIntegration.css';

export type RingCentralConnectionStatus =
  | 'connected'
  | 'connecting'
  | 'offline';

type RingCentralQuickDialProps = {
  connectionStatus: RingCentralConnectionStatus;
  activeCall: ActiveCallDetail | null;
  collapsed: boolean;
  showFab?: boolean;
  onToggleCollapse: () => void;
};

const RingCentralQuickDial = ({
  connectionStatus,
  activeCall,
  collapsed,
  showFab = true,
  onToggleCollapse,
}: RingCentralQuickDialProps) => {
  if (collapsed) {
    if (!showFab) return null;
    return (
      <button
        type="button"
        className="pf-rc-fab"
        title="Open phone"
        aria-label="Open phone"
        onClick={onToggleCollapse}
      >
        <i className="pi pi-phone" aria-hidden />
      </button>
    );
  }

  const badgeClass = activeCall
    ? 'pf-rc-widget__badge pf-rc-widget__badge--active-call'
    : connectionStatus === 'connected'
      ? 'pf-rc-widget__badge pf-rc-widget__badge--connected'
      : connectionStatus === 'connecting'
        ? 'pf-rc-widget__badge pf-rc-widget__badge--pending'
        : 'pf-rc-widget__badge';

  const badgeLabel = activeCall
    ? 'Active Call'
    : connectionStatus === 'connected'
      ? 'Available'
      : connectionStatus === 'connecting'
        ? 'Connecting…'
        : 'Offline';

  return (
    <div className="pf-rc-widget pf-rc-widget--expanded">
      <div className="pf-rc-widget__header">
        <div className="pf-rc-widget__brand">
          <i className="pi pi-phone" aria-hidden />
          <span>Phone</span>
        </div>
        <div className="pf-rc-widget__header-actions">
          <span className={badgeClass}>
            <span className="pf-rc-widget__badge-dot" aria-hidden />
            {badgeLabel}
          </span>
          <button
            type="button"
            className="pf-rc-widget__icon-btn"
            aria-label="Minimize phone"
            title="Minimize"
            onClick={onToggleCollapse}
          >
            <i className="pi pi-minus" aria-hidden />
          </button>
        </div>
      </div>

      {activeCall && (
        <div className="pf-rc-widget__active-call-bar">
          <span className="pf-rc-widget__active-call-name">
            {activeCall.name}
          </span>
          {activeCall.phoneNumber ? (
            <span className="pf-rc-widget__active-call-number">
              {activeCall.phoneNumber}
            </span>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default RingCentralQuickDial;
